import { ReactNode } from 'react';
import { lt } from '@mews/framework';
import { Tag, TagVariant } from '@optimus-web/core';

type PolicyOverrideStatusTag = 'Active' | 'Expired' | 'Scheduled';

interface Props {
    status: PolicyOverrideStatusTag;
}

const policyExceptionStatusTextKeyMap: Record<PolicyOverrideStatusTag, { variant: TagVariant; label: ReactNode }> = {
    Active: {
        label: lt('RateGroupPolicyExceptionStatusActive'),
        variant: 'success',
    },
    Expired: {
        label: lt('RateGroupPolicyExceptionStatusExpired'),
        variant: 'basicBold',
    },
    Scheduled: {
        label: lt('RateGroupPolicyExceptionStatusScheduled'),
        variant: 'warning',
    },
};

export const PolicyExceptionStatusCell = ({ status }: Props) => {
    const { label, variant } = policyExceptionStatusTextKeyMap[status];
    return (
        <Tag outline variant={variant}>
            {label}
        </Tag>
    );
};
